var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4ElectricityMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 50h-4l7-7.95V48h3.46L36 55.1V50zm24-25.16v26.28A10.89 10.89 0 0149.12 62H40v11h-4V62h-9.87A10.14 10.14 0 0116 51.87v-28A9.86 9.86 0 0125.84 14H36V3h4v11h9.16A10.86 10.86 0 0160 24.84zM21.8 27a6.11 6.11 0 006.2 6h19a6 6 0 100-12H28a6.11 6.11 0 00-6.2 6zM56 39H20v12.87A6.14 6.14 0 0026.13 58h23A6.88 6.88 0 0056 51.12V39zm-8-14h-4v4h4v-4zm-8 0h-4v4h4v-4zm-8 0h-4v4h4v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Electricity_meter.4cb8219a.svg";
export { SvgA4ElectricityMeter as ReactComponent };